var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { pdfPageElementClassName } from "./Page";
import { getClassNameForSubstitutionType } from "./PDFSubstitution";
import { PDFHelper } from "./PDFHelper";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var WindowState = /*#__PURE__*/ function (WindowState) { WindowState[WindowState["READY"] = 0] = "READY"; WindowState[WindowState["RENDERING"] = 1] = "RENDERING"; WindowState[WindowState["RENDER_COMPLETE"] = 2] = "RENDER_COMPLETE"; return WindowState; }(WindowState || {});
export var PDFGenContext = /*#__PURE__*/ createContext({ print: function () { return Promise.reject("not setup yet"); }, isPrintingRef: { current: false }, isPrinting: false });
var debug = false;
export var pdfWrapper = debug ? {} : {
    // require clientBoundingRect() to give non-zero values
    visibility: "hidden", height: 0
};
function getStateName(w) { switch (w) {
    case WindowState.READY: return "ready";
    case WindowState.RENDERING: return "rendering";
    case WindowState.RENDER_COMPLETE: return "render-complete";
} }
export function PDFGenProvider(props) {
    var _this = this;
    var _a = useState(WindowState.READY), windowState = _a[0], setWindowState = _a[1];
    var _b = useState(), childToRender = _b[0], setChildToRender = _b[1];
    var _c = useState(), childRef = _c[0], setChildRef = _c[1];
    var _d = useState(false), showPopupBlockedModal = _d[0], setShowPopupBlockedModal = _d[1];
    var _e = useState(), onComplete = _e[0], setOnComplete = _e[1];
    var isPrinting = windowState !== WindowState.READY;
    var isPrintingRef = useRef(false);
    isPrintingRef.current = isPrinting;
    console.log("PDFGen", getStateName(windowState));
    var renderComplete = useCallback(function () { return setWindowState(function (prev) { if (prev !== WindowState.RENDERING) {
        console.warn("invalid state", prev);
        return prev;
    } return WindowState.RENDER_COMPLETE; }); }, []);
    var print = useCallback(function (render, cfg) {
        if (windowState !== WindowState.READY) {
            var err = new Error("invalid window-state " + windowState);
            console.error(err);
            return Promise.reject(err);
        } // set isPrintingRef immediately after function call to prevent callers
        // from calling print() again while we're still rendering
        isPrintingRef.current = true;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () { var element, e_1; return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setWindowState(WindowState.RENDERING);
                    setOnComplete({ resolve: resolve, reject: reject });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, render(renderComplete, cfg)];
                case 2:
                    element = _a.sent();
                    setChildToRender(element);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    setWindowState(WindowState.READY);
                    reject(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        }); }); });
    }, [renderComplete, windowState]);
    useEffect(function () {
        if (windowState !== WindowState.RENDER_COMPLETE)
            return;
        if (!childRef)
            return;
        if (!onComplete)
            return;
        if (!debug)
            setChildToRender(undefined);
        doPageSubstitutions(childRef);
        var styles = Array.from(document.getElementsByTagName("style")).map(function (p) { if (p.innerHTML && p.innerHTML.length > 0)
            return p.outerHTML; var sht = p.sheet; if (sht.cssRules && sht.cssRules.length > 0) {
            var content_1 = Array.from(sht.cssRules).map(function (r) { return r.cssText; }).join("\n");
            return p.outerHTML.replace("</style>", content_1 + "</style>");
        } return p.outerHTML; }); // eslint-disable-next-line no-restricted-globals
        var host = location.protocol + "//" + location.host; // links needed for font-refs
        var links = Array.from(document.getElementsByTagName("link")).map(function (p) { return p.outerHTML.replace(/(href=["'])\//g, "$1" + host + "/"); }); // fix page size so that page breaks work correctly
        styles.push("<style>body { height: auto; width: auto; position: relative; }</style>");
        var body = childRef.innerHTML;
        var content = __spreadArray(__spreadArray(__spreadArray([document.doctype ? new XMLSerializer().serializeToString(document.doctype) : "", // doctype matters for default user-agent stylesheets
            "<html>", "<meta charset=\"utf-8\" />"], links, true), styles, true), ["<body style=\"-webkit-print-color-adjust:exact; margin: 0; padding: 0;\">", body, "</body></html>"], false).join("\n");
        try {
            onComplete.resolve(content);
        }
        catch (e) { }
        setWindowState(WindowState.READY);
        isPrintingRef.current = false;
    }, [windowState, childRef, onComplete]);
    var ctx = useMemo(function () { return { print: print, isPrinting: isPrinting, isPrintingRef: isPrintingRef }; }, [print, isPrinting]);
    return /*#__PURE__*/ _jsxs(React.Fragment, { children: [/*#__PURE__*/ _jsx(PDFHelper, { childToRender: childToRender, setChildRef: setChildRef, setShowPopupBlockedModal: setShowPopupBlockedModal, showPopupBlockedModal: showPopupBlockedModal }), /*#__PURE__*/ _jsx(PDFGenContext.Provider, { value: ctx, children: props.children })] });
}
function doPageSubstitutions(ref) { var elements = Array.from(ref.getElementsByClassName(pdfPageElementClassName)); var pageCount = elements.length; elements.map(function (e, index) { var placeholders = Array.from(e.getElementsByClassName(getClassNameForSubstitutionType("page-no"))); placeholders.map(function (el) { return el.innerHTML = (index + 1).toString(); }); placeholders = Array.from(e.getElementsByClassName(getClassNameForSubstitutionType("page-count"))); placeholders.map(function (el) { return el.innerHTML = pageCount.toString(); }); return null; }); }
